import type { UpdateArtistDirectorySearch } from "@/features/feature-page/artist-directory";
import type { ArtistDirectorySearchState } from "@/features/feature-page/artist-directory-query";
import { FeaturePageContent } from "@/features/feature-page/feature-page-content";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export function FeaturePageView({
  page,
  directorySearch,
  updateDirectorySearch,
}: {
  page: FeaturePageRenderModel;
  directorySearch: ArtistDirectorySearchState;
  updateDirectorySearch: UpdateArtistDirectorySearch;
}) {
  return (
    <>
      <FeaturePageContent
        page={page}
        directorySearch={directorySearch}
        updateDirectorySearch={updateDirectorySearch}
      />
    </>
  );
}
